import boxShadows from "assets/theme/box-shadow.js";
import themeColors from "assets/theme/colors";
import hexToRgb from "assets/theme/hex-to-rgb.js";
import { IS_PROD_ENV } from "constants/environment";
import { getColorByEnv } from "utils/get-colors-by-env";

const componentStyles = (theme) => ({
  appBarRoot: {
    backgroundColor: !IS_PROD_ENV ? "#ADD8E6" : themeColors.info.main,
  },
  brandTitle: {
    textTransform: "uppercase",
    margin: "0",
    color: themeColors.white.main,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  searchBoxShow: {
    display: "flex!important",
    marginRight: "0",
    "& div:first-of-type": {
      flex: 1,
    },
  },
  searchBox: {
    borderColor: theme.palette.adminNavbarSearch.main,
    borderRadius: "2rem",
    border: "2px solid",
    backgroundColor: "rgba(" + hexToRgb(themeColors.white.main) + ",0.9)",
    boxShadow: boxShadows.inputBoxShadow,
    transition: "box-shadow .15s ease",
    [theme.breakpoints.down("xs")]: {
      display: "none",
      width: "100%",
    },
  },
  searchIcon: {
    color: getColorByEnv(),
    marginRight: "0.5rem",
    marginLeft: "1rem",
  },
  searchClose: {
    color: getColorByEnv(),
    marginRight: "1rem",
    marginLeft: "-.5rem",
  },
  searchInput: {
    color: themeColors.gray[900],
    width: "100%",
    backgroundColor: "initial",
    border: 0,
    boxShadow: "none",
    padding: "0",
  },
});

export default componentStyles;
